export const translations = {
  nl: {
    // Navigation
    nav: {
      welcome: 'Welkom',
      cases: 'Voorbeelden',
      sponsor: 'Sponsor',
      rules: 'Spelregels',
      process: 'Hoe werkt het',
      costs: 'Kosten',
      about: 'Over ons'
    },

    // Hero Section
    hero: {
      badge: 'Snelle Bedrijfsfinanciering',
      title: 'Financiering geregeld binnen 24 uur',
      subtitle: 'Bladt Bridge Loan financiert ook alternatieve onderpanden',
      description: 'Direct liquiditeit nodig? Bladt Bridge Loan biedt financiering via maatwerkoplossingen',
      quickCredit: 'Lening kan binnen enkele dagen worden verstrekt – Bijna 24/7 geopend',
      viewCases: 'Bekijk Voorbeelden',
      applyNow: 'Neem Contact Op'
    },

    // Intro Section
    intro: {
      title: 'Direct liquiditeit nodig?',
      text: 'Bladt Bridge Loan is er voor ondernemers, family offices, en intermediairs die snel, discreet en op maat gefinancierd willen worden. Onder leiding van Cor Bladt biedt Bladt Bridge Loan tijdelijke liquiditeitsoplossingen waar reguliere financiers afhaken. Van noodkredieten bij doorstarts tot beleningen op kunst, auto\'s, horloges en of vastgoed. Snelheid, zekerheid en flexibiliteit staan daarbij steeds centraal.'
    },

    // Value Proposition
    value: {
      title: 'Waarom Bladt Bridge Loan?',
      fast: {
        title: 'Snelle Beslissing',
        desc: 'Direct contact met beslissers, binnen enkele uren antwoord'
      },
      discrete: {
        title: 'Discreet & Vertrouwelijk',
        desc: 'Volledige discretie gegarandeerd bij alle transacties'
      },
      flexible: {
        title: 'Flexibel Maatwerk',
        desc: 'Oplossingen waar reguliere financiers afhaken'
      }
    },

    // Sponsor Section
    sponsor: {
      title: 'Hoofdsponsor Utrecht Dragons',
      subtitle: 'Trots partner van ijshockey',
      text: 'Bladt Bridge Loan is met trots hoofdsponsor geworden van de Utrecht Dragons. Als ambitieus bedrijf geloven wij in het ondersteunen van topsport en lokaal talent. De samenwerking met de Dragons past perfect bij onze filosofie: snelheid, teamwork en het bereiken van doelen.',
      readMore: 'Lees meer',
      readMoreArrow: 'Lees hierover',
      link: 'https://utrechtdragons.nl/2025/11/08/sponsorcontract-bladt-bridge-loan-met-utrecht-dragons/'
    },

    // Cases Section
    cases: {
      title: 'Financieringsvoorbeelden',
      subtitle: 'Bladt Bridge Loan financiert ook alternatieve onderpanden',
      readMore: 'Lees meer',
      readLess: 'Minder',

      case1: {
        keyword: 'Doorstarts',
        title: 'Doorstart Financiering',
        text: 'In samenwerking met o.a. Capital Now organiseren wij doorstarten van levensvatbare bedrijven. Als een bank een krediet opzegt en er dreigt faillissement, maken wij een analyse van de levensvatbaarheid. Bij een positieve uitkomst kan Bladt Bridge Loan het verschil maken door de inboedel als onderpand te nemen en de doorstart te financieren. Tijdens de doorstart zoeken we al direct naar een reguliere financier zoals een crowdfunder of parallelle financier voor de langere termijn.'
      },

      case2: {
        keyword: 'Private Banking',
        title: 'Vermogensbeheer & Private Offices',
        text: 'Vermogende family offices hebben regelmatig snel liquiditeit nodig terwijl hun vermogen is geïnvesteerd. Via intermediairs zoals Ronald Bax van Armsborg kunnen we binnen enkele dagen liquiditeit verschaffen. Of het nu gaat om een acute investeringsmogelijkheid of tijdelijke liquiditeitsbehoefte - wij bieden een snelle oplossing met directe communicatie. Vervroegde aflossing is altijd mogelijk zonder boete, wat zorgt voor maximale flexibiliteit.'
      },

      case3: {
        keyword: 'Kunst',
        title: 'Kunstcollecties Belenen',
        text: 'Kunstcollecties kunnen binnen enkele dagen worden belend. Een gerenommeerde galeriehouder uit Amsterdam beoordeelt de herkomst en authenticiteit van de werken. Bij goedkeuring wordt het kunstwerk in vuistpand genomen en beveiligd opgeslagen in een gecertificeerde kluis. Een notariële akte legt alle rechten en plichten vast. De lener kan het kunstwerk op dagbasis terugkrijgen zodra de lening is terugbetaald.'
      },

      case4: {
        keyword: 'Vermogenden',
        title: 'Vermogenden & Family Offices',
        text: 'Meer dan de helft van onze leningen gaat naar vermogenden die snel, discreet en flexibel gefinancierd willen worden. Na een eerste uitvoerige screening ontstaat een vertrouwensrelatie waarbij snelheid centraal staat. Er zijn voorbeelden bekend waarbij we op zaterdagavond werden gebeld en op dinsdag de akte werd gepasseerd. De Loan-to-Value (LTV) is dan niet het belangrijkste - we financieren regelmatig aankoop plus kosten. Terugbetaling vindt meestal plaats binnen 2-8 weken.'
      },

      case5: {
        keyword: 'Wagenparken',
        title: 'Auto & Wagenparkfinanciering',
        text: 'Bladt Bridge Loan is één van de weinige partijen die bereid is om exclusieve wagenparken en autocollecties te financieren. Een voorbeeld: een bekende Nederlander had een collectie ter waarde van €7 miljoen en kreeg op basis hiervan een lening van €4 miljoen. De auto\'s werden op naam van Bladt Bridge loan gezet met aangepaste verzekering waarbij de lener premiebetaler bleef en Bladt Bridge Loan begunstigde. De collectie kon bij de eigenaar blijven staan in zijn museum.'
      },

      case6: {
        keyword: 'Projectontwikkeling',
        title: 'Projectontwikkeling',
        text: 'Voor een selecte groep projectontwikkelaars financieren wij ook hoger risico projecten. Dit gebeurt altijd met een derde partij - vaak familie maar niet altijd - die garant staat voor de lening. Hierdoor kunnen ontwikkelaars projecten met hoge marges realiseren of afronden die anders niet gefinancierd zouden worden. De garantstelling maakt het voor ons mogelijk om buiten ons standaard risicoprofiel te treden.'
      },

      case7: {
        keyword: 'Horloges',
        title: 'Exclusieve Horlogecollecties',
        text: 'In samenwerking met de marktleider op het gebied van luxe horloges nemen wij dure horloges en horlogecollecties in onderpand. De potentiële lener gaat naar de door ons aangewezen juwelier die onderzoek doet naar herkomst en staat van de horloges - een enkele kras kan de waarde met duizenden euro\'s verminderen. De horloges worden uitgebreid gefotografeerd en opgeslagen in de kluis van de juwelier. Na terugbetaling wordt het horloge op dagbasis vrijgegeven.'
      },

      case8: {
        keyword: 'Schepen',
        title: 'Scheepsfinanciering',
        text: 'Voor een select groepje vertrouwde relaties nemen we ook boten en schepen in onderpand. Gezien het hogere risicoprofiel dient er altijd extra zekerheid te zijn en wordt op het schip een hypotheek ingeschreven. Deze vorm van financiering wordt alleen aangeboden aan bestaande relaties met een bewezen track record.'
      },

      case9: {
        keyword: 'Factoring',
        title: 'Factoringfinanciering',
        text: 'Wij verstrekken regelmatig bevoorschotting op facturen vanaf €100.000. Het starttarief voor factoring bedraagt 10%. De factuur moet bekend zijn bij de betalende klant en er mag op geen enkele manier betwisting zijn. De factuur wordt aangepast en dient voldaan te worden op een rekeningnummer van Bladt Bridge Loan. Dit biedt ondernemers directe liquiditeit op basis van uitstaande vorderingen.'
      }
    },

    // Rules Section (Spelregels)
    rules: {
      title: 'Onze Spelregels in het Kort',
      subtitle: 'Transparante voorwaarden voor succesvolle samenwerking',
      items: [
        'Minimale leningomvang bedraagt €100.000 (afhankelijk van onderpand en situatie)',
        'Financiering uitsluitend met concreet onderpand (kunst, auto\'s, horloges, boten, inventaris, facturen, etc.)',
        'Altijd een duidelijke herkomst en waardebepaling van het onderpand vereist',
        'Bij financiering van doorstarts: eerst analyse van haalbaarheid en levensvatbaarheid',
        'Notariële akte bij alle transacties, inclusief afspraken over rechten en plichten',
        'Lening kan doorgaans binnen enkele dagen worden verstrekt',
        'Aflossing mogelijk op dagbasis; vervroegde terugbetaling zonder boete',
        'Tarief afhankelijk van risico en looptijd (kort, flexibel en transparant)',
        'Extra zekerheden of mede-ondertekening verplicht bij hogere risico\'s',
        'Volledige discretie en directe communicatie met beslissers',
        'Alleen op uitnodiging of via betrouwbare intermediairs'
      ]
    },

    // Process
    process: {
      title: 'Hoe werkt het?',
      subtitle: 'Van eerste contact tot uitbetaling',
      steps: [
        {
          title: 'Contact',
          desc: 'Direct contact met Cor Bladt voor een snelle beoordeling'
        },
        {
          title: 'Beoordeling',
          desc: 'Vaak binnen enkele uren een haalbaarheid en indicatief tarief'
        },
        {
          title: 'Onderpand',
          desc: 'Waardebepaling en controle van het aangeboden onderpand'
        },
        {
          title: 'Notaris',
          desc: 'Notariële akte waarin alle rechten en plichten worden vastgelegd'
        },
        {
          title: 'Uitbetaling',
          desc: 'Snelle uitbetaling'
        }
      ]
    },

    // Costs
    costs: {
      title: 'Kosten',
      subtitle: 'Onderstaande bedragen zijn afhankelijk van hoogte leensom, periode lening, geboden zekerheden en andere relevante zaken.',
      items: {
        closing: 'Afsluitprovisie',
        standby: 'Bereidstellingsprovisie',
        interest: 'Rentevergoeding',
        exit: 'Exitprovisie',
        notary: 'Notariskosten'
      },
      values: {
        closing: 'vanaf 1.5%',
        standby: 'vanaf 0.4%',
        interest: 'vanaf 1.00% per maand',
        exit: 'vanaf 1.5%',
        notary: 'Variabel'
      }
    },

    // CTA Section
    cta: {
      title: 'Direct kapitaal nodig?',
      text: 'Heeft u of uw cliënt direct kapitaal nodig en telt elke dag? Neem contact op met Bladt Bridge Loan voor een snelle en vertrouwelijke beoordeling.',
      subtext: '',
      callNow: 'Bel Nu',
      emailNow: 'Email Nu'
    },

    // About
    about: {
      title: 'Over Bladt Bridge Loan',
      p1: 'Bladt Bridge Loan zorgt voor het financieren van korte termijn leenbehoefte. Onder leiding van Cor Bladt hebben we bedrijfsmatig veel kennis en ervaring opgedaan met het financieren van ondernemers, family offices en doorstarts.',
      p2: 'We financieren vanaf €100.000 tot €5.000.000, hogere aanvragen zijn mogelijk hiervoor zijn er andere criteria. Leningen zijn mogelijk van 1 week tot maximaal 1 jaar. We kunnen en willen alleen bedrijven financieren die in Nederland zijn gevestigd, of onderpand zich in Nederland bevindt. Er moeten voldoende uit te winnen zekerheden worden afgegeven, zoals bijvoorbeeld onbelast onroerend goed, aandelenportefeuilles, waardevolle bezittingen zoals kunst, horloges, auto\'s en boten.',
      contact: 'Contact',
      company: 'Bladt Bridge Loan',
      address1: 'Groenekanseweg 70',
      address2: '3732 AG DE BILT',
      disclaimer: 'Bladt Bridge Loan is een handelsnaam van Bladt & Zn. B.V. en geregistreerd bij de KVK Utrecht onder nummer 80276954.'
    },

    // Calculator Form
    calculator: {
      title: 'Bereken uw financiering',
      subtitle: 'Vraag direct een vrijblijvende offerte aan',
      speedBadge: 'Snelste op de markt',
      speedText: 'Vul het formulier in of bel ons en u aanvraag is binnen enkele dagen geregeld. Wij zijn de snelste financier van Nederland.',
      loanAmount: 'Gewenst leenbedrag',
      aboveFiveInfo: 'Boven €5.000.000 is mogelijk met het juiste onderpand',
      collateralType: 'Type onderpand',
      collateralOptions: {
        inventory: 'Inventaris / Doorstart',
        art: 'Kunst',
        cars: 'Auto\'s / Wagenpark',
        watches: 'Horloges',
        ships: 'Schepen / Boten',
        realEstate: 'Vastgoed',
        invoices: 'Facturen',
        shares: 'Aandelen',
        other: 'Anders'
      },
      otherCollateral: 'Beschrijf uw onderpand',
      companyName: 'Bedrijfsnaam',
      phone: 'Telefoonnummer',
      email: 'E-mailadres',
      submit: 'Aanvraag versturen',
      sending: 'Versturen...',
      success: 'Uw aanvraag is verstuurd! Wij streven ernaar zo snel mogelijk te reageren met een indicatie van de tarieven.',
      successExtra: 'Tip: Stuur alvast uw casus naar c.bladt@bvgd.nl met informatie over het onderpand en jaarcijfers - dit versnelt het proces!',
      tariffsNote: 'Na ontvangst van uw aanvraag ontvangt u een indicatie van de tarieven.',
      error: 'Er is iets misgegaan. Probeer het opnieuw of bel ons direct.',
      required: 'Verplicht veld'
    },

    // LinkedIn Feed
    linkedin: {
      title: 'Onze Leningen & Casussen',
      subtitle: 'Zie een overzicht van al onze leningen en casussen die we hebben gedaan'
    },

    // Footer
    footer: {
      copyright: '© Copyright - Bladt Bridge Loan'
    }
  },

  en: {
    // Navigation
    nav: {
      welcome: 'Welcome',
      cases: 'Examples',
      sponsor: 'Sponsor',
      rules: 'Our Rules',
      process: 'How it works',
      costs: 'Costs',
      about: 'About us'
    },

    // Hero Section
    hero: {
      badge: 'Fast Business Financing',
      title: 'Financing Arranged Within 24 Hours',
      subtitle: 'Bladt Bridge Loan Also Finances Alternative Collateral',
      description: 'Need immediate liquidity? Bladt Bridge Loan offers financing through customised solutions',
      quickCredit: 'Loans Can Be Provided Within Days – Nearly 24/7 Open',
      viewCases: 'View Examples',
      applyNow: 'Contact Us'
    },

    // Intro Section
    intro: {
      title: 'Need immediate liquidity?',
      text: 'Bladt Bridge Loan is here for entrepreneurs, family offices, and intermediaries who need fast, discreet, and customised financing. Under the leadership of Cor Bladt, Bladt Bridge Loan provides temporary liquidity solutions where regular financiers decline. From emergency credits for restarts to loans secured by art, cars, watches and or real estate. Speed, security, and flexibility are always central.'
    },

    // Value Proposition
    value: {
      title: 'Why Bladt Bridge Loan?',
      fast: {
        title: 'Fast Decision',
        desc: 'Direct contact with decision makers, response within hours'
      },
      discrete: {
        title: 'Discreet & Confidential',
        desc: 'Complete discretion guaranteed for all transactions'
      },
      flexible: {
        title: 'Flexible Solutions',
        desc: 'Solutions where regular financiers decline'
      }
    },

    // Sponsor Section
    sponsor: {
      title: 'Main Sponsor Utrecht Dragons',
      subtitle: 'Proud partner of ice hockey',
      text: 'Bladt Bridge Loan is proud to have become the main sponsor of Utrecht Dragons. As an ambitious company, we believe in supporting top sports and local talent. The partnership with the Dragons fits perfectly with our philosophy: speed, teamwork, and achieving goals.',
      readMore: 'Read more',
      readMoreArrow: 'Read more',
      link: 'https://utrechtdragons.nl/2025/11/08/sponsorcontract-bladt-bridge-loan-met-utrecht-dragons/'
    },

    // Cases Section
    cases: {
      title: 'Financing Examples',
      subtitle: 'Bladt Bridge Loan Also Finances Alternative Collateral',
      readMore: 'Read more',
      readLess: 'Less',

      case1: {
        keyword: 'Restarts',
        title: 'Restart Financing',
        text: 'In collaboration with, amongst others, Capital Now, we organise restarts of viable companies. When a bank terminates credit and bankruptcy threatens, we analyse viability. With a positive outcome, Bladt Bridge Loan can make the difference by taking inventory as collateral and financing the restart. During the restart, we immediately seek a regular financier such as a crowdfunder for the longer term.'
      },

      case2: {
        keyword: 'Private Banking',
        title: 'Wealth Management & Private Offices',
        text: 'Wealthy family offices regularly need quick liquidity whilst their assets are invested. Through intermediaries like Ronald Bax of Armsborg, we can provide liquidity within days. Whether it is an acute investment opportunity or temporary liquidity needs - we offer a fast solution with direct communication. Early repayment is always possible without penalty, ensuring maximum flexibility.'
      },

      case3: {
        keyword: 'Art',
        title: 'Art Collections as Collateral',
        text: 'Art collections can be financed within days. A renowned gallery owner from Amsterdam assesses the provenance and authenticity of the works. Upon approval, the artwork is taken as collateral and securely stored in a certified vault. A notarial deed records all rights and obligations. The borrower can retrieve the artwork on a daily basis once the loan is repaid.'
      },

      case4: {
        keyword: 'High Net Worth',
        title: 'High Net Worth & Family Offices',
        text: 'More than half of our loans go to high-net-worth individuals who want fast, discreet, and flexible financing. After an initial thorough screening, a relationship of trust develops where speed is central. There are known examples where we were called on Saturday evening and the deed was passed on Tuesday. The Loan-to-Value (LTV) is not the most important - we regularly finance purchase plus costs. Repayment usually takes place within 2-8 weeks.'
      },

      case5: {
        keyword: 'Car Collections',
        title: 'Car & Fleet Financing',
        text: 'Bladt Bridge Loan is one of the few parties that is willing to finance exclusive car fleets and collections. Example: a well-known Dutchman had a collection worth €7 million and received a loan of €4 million based on this. The cars were registered in Bladt Bridge loan name with adjusted insurance where the borrower remained premium payer and Bladt Bridge Loan beneficiary. The collection could remain with the owner in his museum.'
      },

      case6: {
        keyword: 'Real Estate Development',
        title: 'Project Development',
        text: 'For a select group of project developers, we also finance higher risk projects. This always happens with a third party - often family but not always - who guarantees the loan. This allows developers to realize or complete projects with high margins that would otherwise not be financed. The guarantee makes it possible for us to step outside our standard risk profile.'
      },

      case7: {
        keyword: 'Watches',
        title: 'Exclusive Watch Collections',
        text: 'In collaboration with the market leader in luxury watches, we accept expensive watches and watch collections as collateral. The potential borrower goes to the jeweler designated by us who researches the origin and condition of the watches - a single scratch can reduce the value by thousands of euros. The watches are extensively photographed and stored in the jeweler vault. After repayment, the watch is released on a daily basis.'
      },

      case8: {
        keyword: 'Ships',
        title: 'Ship Financing',
        text: 'For a select group of trusted relationships, we also accept boats and ships as collateral. Given the higher risk profile, there must always be additional security and a mortgage is registered on the ship. This form of financing is only offered to existing relationships with a proven track record.'
      },

      case9: {
        keyword: 'Factoring',
        title: 'Invoice Factoring',
        text: 'We regularly provide advances on invoices from €100,000. The starting rate for factoring is 10%. The invoice must be known to the paying customer and there must be no dispute whatsoever. The invoice is adjusted and must be paid to an account number of Bladt Bridge Loan. This provides entrepreneurs with immediate liquidity based on outstanding receivables.'
      }
    },

    // Rules Section
    rules: {
      title: 'Our Rules in Short',
      subtitle: 'Transparent conditions for successful cooperation',
      items: [
        'Minimum loan size is €100,000 (depending on collateral and situation)',
        'Financing exclusively with concrete collateral (art, cars, watches, boats, inventory, invoices, etc.)',
        'Always a clear origin and valuation of the collateral required',
        'For restart financing: first analysis of feasibility and viability',
        'Notarial deed for all transactions, including agreements on rights and obligations',
        'Loan can usually be provided within days',
        'Repayment possible on a daily basis; early repayment without penalty',
        'Rate depending on risk and duration (short, flexible and transparent)',
        'Additional securities or co-signing required for higher risks',
        'Complete discretion and direct communication with decision makers',
        'Only by invitation or through trusted intermediaries'
      ]
    },

    // Process
    process: {
      title: 'How does it work?',
      subtitle: 'From first contact to payout',
      steps: [
        {
          title: 'Contact',
          desc: 'Direct contact with Cor Bladt for a quick assessment'
        },
        {
          title: 'Assessment',
          desc: 'Often within hours a feasibility and indicative rate'
        },
        {
          title: 'Collateral',
          desc: 'Valuation and verification of the offered collateral'
        },
        {
          title: 'Notary',
          desc: 'Notarial deed in which all rights and obligations are recorded'
        },
        {
          title: 'Payout',
          desc: 'Fast payout'
        }
      ]
    },

    // Costs
    costs: {
      title: 'Costs',
      subtitle: 'The amounts below depend on the loan amount, loan period, offered securities and other relevant matters.',
      items: {
        closing: 'Closing fee',
        standby: 'Standby fee',
        interest: 'Interest compensation',
        exit: 'Exit fee',
        notary: 'Notary costs'
      },
      values: {
        closing: 'from 1.5%',
        standby: 'from 0.4%',
        interest: 'from 1.00% per month',
        exit: 'from 1.5%',
        notary: 'Variable'
      }
    },

    // CTA Section
    cta: {
      title: 'Need immediate capital?',
      text: 'Do you or your client need immediate capital and does every day count? Contact Bladt Bridge Loan for a fast and confidential assessment.',
      subtext: '',
      callNow: 'Call Now',
      emailNow: 'Email Now'
    },

    // About
    about: {
      title: 'About Bladt Bridge Loan',
      p1: 'Bladt Bridge Loan provides short-term loan financing. Under the leadership of Cor Bladt, we have gained extensive business knowledge and experience in financing entrepreneurs, family offices and restarts.',
      p2: 'We finance from €100,000 to €5,000,000, higher applications are possible for which there are other criteria. Loans are possible from 1 week to a maximum of 1 year. We can and will only finance companies that are based in the Netherlands, or collateral is located in the Netherlands. Sufficient collateral must be provided, such as unencumbered real estate, share portfolios, valuable possessions such as art, watches, cars and boats.',
      contact: 'Contact',
      company: 'Bladt Bridge Loan',
      address1: 'Groenekanseweg 70',
      address2: '3732 AG DE BILT',
      disclaimer: 'Bladt Bridge Loan is a trade name of Bladt & Zn. B.V. and registered with the Chamber of Commerce Utrecht under number 80276954.'
    },

    // Calculator Form
    calculator: {
      title: 'Calculate your financing',
      subtitle: 'Request a no-obligation quote directly',
      speedBadge: 'Fastest on the market',
      speedText: 'Fill in the form or call us and your application will be arranged within days. We are the fastest financier in the Netherlands.',
      loanAmount: 'Desired loan amount',
      aboveFiveInfo: 'Above €5,000,000 is possible with the right collateral',
      collateralType: 'Type of collateral',
      collateralOptions: {
        inventory: 'Inventory / Restart',
        art: 'Art',
        cars: 'Cars / Fleet',
        watches: 'Watches',
        ships: 'Ships / Boats',
        realEstate: 'Real Estate',
        invoices: 'Invoices',
        shares: 'Shares',
        other: 'Other'
      },
      otherCollateral: 'Describe your collateral',
      companyName: 'Company name',
      phone: 'Phone number',
      email: 'Email address',
      submit: 'Submit request',
      sending: 'Sending...',
      success: 'Your request has been sent! We strive to respond as quickly as possible with a rate indication.',
      successExtra: 'Tip: Send your case to c.bladt@bvgd.nl with collateral info and annual figures - this speeds up the process!',
      tariffsNote: 'After receiving your request, you will receive a rate indication.',
      error: 'Something went wrong. Please try again or call us directly.',
      required: 'Required field'
    },

    // LinkedIn Feed
    linkedin: {
      title: 'Our Loans & Cases',
      subtitle: 'See an overview of all our loans and cases we have completed'
    },

    // Footer
    footer: {
      copyright: '© Copyright - Bladt Bridge Loan'
    }
  }
};
